export const MODEL_LABELS: Record<string, string> = {
  prob_vente: "Modèle standard",
  prob_vente_custom: "Modèle personnalisé",
};

export const getModelLabel = (modelName: string) =>
  MODEL_LABELS[modelName] ?? modelName;

export const MODEL_COLORS: Record<string, string> = {
  prob_vente: "var(--mui-palette-chart-model)",
  prob_vente_custom: "var(--mui-palette-chart-series-1)",
};

export const VARIABLE_LABELS: Record<string, string> = {
  type_client_nom_court: "Type client",
  canal_nandc_code: "Canal",
  code_tarifaire_nandc_code: "Code tarifaire",
  los_disc: "LOS catégorie",
  pays_nandc_code: "Pays",
  uh_type_nandc_code: "Type UH",
  lead_time_reservation_calc: "Lead time réservation",
  revenu_hebergement_nuitee_ht: "Revenu hébergement / nuitée",
};

export const METRIC_EXPLANATIONS: Record<
  string,
  { label: string; simple: string; detail: string }
> = {
  accuracy: {
    label: "Accuracy",
    simple: "% de prédictions correctes en tout",
    detail:
      "Sur 100 réservations, combien le modèle a bien classé (annulée ou confirmée) ? ⚠️ Trompeuse quand les annulations sont rares : un modèle qui dit «jamais annulé» aurait 98% mais serait inutile.",
  },
  balanced_accuracy: {
    label: "Balanced Accuracy",
    simple: "Accuracy corrigée pour les classes déséquilibrées",
    detail:
      "Moyenne du taux de bonne détection sur chaque classe (annulées ET confirmées). Contrairement à l'Accuracy simple, elle n'est pas biaisée par le fait que les annulations sont rares. 50% = aussi mauvais que le hasard.",
  },
  auc_roc: {
    label: "AUC-ROC",
    simple: "Capacité à distinguer «va annuler» de «va rester»",
    detail:
      "Indépendant du seuil de décision. 100% = modèle parfait, 50% = pile ou face. C'est la métrique la plus fiable pour comparer des modèles. Privilégiez ce score pour choisir le meilleur modèle.",
  },
  mcc: {
    label: "MCC (normalisé)",
    simple: "Corrélation globale entre prédictions et réalité",
    detail:
      "Le Matthews Correlation Coefficient est le plus robuste sur données déséquilibrées. Normalisé ici de 0 à 1 (0.5 = hasard, 1 = parfait). Il prend en compte tous les cas : vrais positifs, vrais négatifs, fausses alertes et annulations ratées.",
  },
};

export const METRICS = Object.keys(METRIC_EXPLANATIONS) as Array<
  keyof typeof METRIC_EXPLANATIONS
>;

export const pct = (v: number) => `${(v * 100).toFixed(1)}%`;
